export default "__VITE_ASSET__CguRo27D__"